<template>
  <div class="employee-file-history">
    <a>
      <span class="modal-body-text">
        Participant: {{ firstName }} {{ lastName }} &nbsp; &nbsp; &nbsp;
        {{ birthDate }} &nbsp; &nbsp; &nbsp;
        {{ data.profile.data && data.profile.data.email }} </span
      ><br /><br />
    </a>
    <DataTable
      :items="(employeeFileHistoryList && employeeFileHistoryList.data) || []"
      :fields="eligibilityField"
      :total="
        (employeeFileHistoryList.meta &&
          employeeFileHistoryList.meta.pagination.total) ||
          0
      "
      :page="pagingObj.page || 1"
      :limit="pagingObj.limit || 1"
      @datatable-change="handleDataTableChange"
    ></DataTable>
  </div>
</template>

<script>
import { TheMask } from "../../components/utils/vue-the-mask";
import moment from "moment";
import DataTable from "@/components/datatable/DataTable";
import { mapActions, mapGetters } from "vuex";
import {
  ACTION_GET_EMPLOYEE_FILE_HISTORY,
  GETTERS_EMPLOYEE_FILE_HISTORY
} from "@/store/modules/employees/constants";
export default {
  name: "show-employee-file-history",
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    TheMask,
    moment,
    DataTable
  },
  data() {
    return {
      tabIndex: 0,
      pagingObj: {
        page: 1,
        limit: 5,
        orderBy: "created_at",
        sortedBy: "asc",
        search: "",
        sortDesc: false
      },
      date_format: "DD/MM/YYYY",
      eligibilityFromFilter: null,
      eligibilityToFilter: null,
      biometricFromFilter: null,
      biometricToFilter: null,
      incentiveFromFilter: null,
      incentiveToFilter: null,
      biometric_type: "biometrics_data",
      incentive_type: "incentive_points_data",
      eligibility_type: "eligibility_data",
      eligibilityField: [
        {
          key: "transaction_file_name",
          label: "Eligibility File",
          sortable: true
        },
        {
          key: "created_at",
          label: "Date",
          type: "date",
          sortable: true
        }
      ],
      employeeFileHistory: {
        eligibility: []
      }
    };
  },
  computed: {
    firstName() {
      return (
        this.data.profile &&
        this.data.profile.data &&
        this.data.profile.data.first_name
      );
    },
    lastName() {
      return (
        this.data.profile &&
        this.data.profile.data &&
        this.data.profile.data.last_name
      );
    },
    birthDate() {
      return (
        this.data.profile &&
        this.data.profile.data &&
        this.data.profile.data.birth_date
      );
    },
    ...mapGetters({
      employeeFileHistoryList: GETTERS_EMPLOYEE_FILE_HISTORY
    })
  },
  methods: {
    eligibilityItemFilter: function(item) {
      let dateFrom = moment("01/01/1970", this.date_format);
      let dateTo = moment("31/12/9999", this.date_format);
      if (
        this.eligibilityFromFilter !== "" &&
        this.eligibilityFromFilter !== null
      ) {
        dateFrom = moment(this.eligibilityFromFilter, this.date_format);
      }
      if (
        this.eligibilityToFilter !== "" &&
        this.eligibilityToFilter !== null
      ) {
        dateTo = moment(this.eligibilityToFilter, this.date_format);
      }
      let first = dateFrom <= moment(item.created_at, "YYYY-MM-DD");
      let second = moment(item.created_at, "YYYY-MM-DD") <= dateTo;
      return first && second;
    },
    onEligibilityFiltered: function(filteredItems) {
      this.pagingObj.total = filteredItems.length;
      this.pagingObj.page = 1;
    },
    handleDataTableChange: function(data) {
      this.getEmployeeFileHistory({
        id: this.data.id,
        params: { ...data }
      });
    },
    ...mapActions({
      getEmployeeFileHistory: ACTION_GET_EMPLOYEE_FILE_HISTORY
    })
  },
  beforeMount: function() {
    this.getEmployeeFileHistory({
      id: this.data.id,
      params: { ...this.pagingObj }
    });
  }
};
</script>

<style lang="less">
#showEmployeeFileHistory {
  .modal-header {
    width: auto;
    border-bottom: none;
    .modal-header-text {
      margin-top: 30px;
      margin-left: 30px;
      font-size: 1.25rem;
      font-weight: bold;
      line-height: 1.688rem;
      color: #1C1C1C;
    }
  }
  .modal-body {
    width: auto;
    margin-left: 30px;
    margin-right: 30px;
    .modal-body-text {
      height: 17px;
      width: 377px;
      color: #1C1C1C;
      font-size: 12px;
      letter-spacing: -0.38px;
      line-height: 17px;
    }
    .tabs {
      .nav-tabs {
        border-bottom: none;
        .nav-item {
          margin-bottom: 0px;
          padding-left: 0px;
          .nav-link {
            border: none;
            text-align: left;
            color: #BFBFBF;
            background: transparent;
            font-size: 0.875rem;
            font-weight: 600;
            line-height: 1.1875rem;
            cursor: pointer;
            padding-left: 0px;
            &.active span {
              border-bottom: 3px solid #1674CD;
              padding-bottom: 5px;
              color: #1674CD;
            }
          }
        }
      }
      .tab-content {
        margin-top: 0px;
        border: none;
        .tab-pane {
          padding-left: 0px;
          .date-filter {
            text-align: right;
            font-size: 0.75rem;
            line-height: 1.063rem;
            span {
              margin-left: 10px;
              margin-right: 5px;
            }
            .form-control {
              width: auto;
              display: inline-block;
              padding: 0.25rem 0.5rem;
              font-size: 0.75rem;
              line-height: 1.063rem;
              &::placeholder {
                opacity: 0.5;
              }
            }
          }
          .datatable-table {
            & th {
              padding-left: 0px;
              &:focus {
                outline: none;
              }
            }
            & th,
            & td {
              border: none;
            }
          }
          .pagination {
            .page-item {
              .page-link {
                border: none;
              }
              &.active {
                outline: none;
                &:focus {
                  outline: none;
                }
                .page-link {
                  border-color: #1674CD;
                  font-weight: bold;
                  &.active:focus {
                    outline: none;
                    box-shadow: none;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/ShowEmployeeFileHistory.vue